import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deletePlanTodo = defineEndpoint({
  method: 'DELETE',
  path: '/v1/release-plans/:planId/todos/:todoId',
  params: z.object({ planId: z.string().uuid(), todoId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
